import { IFormProgress } from "../_common/interface/form/iFormProgress.interface";

export function formatRemainingTime(seconds?: number) {
    if (!seconds || seconds <= 0) return "0 min";

    const mins = Math.ceil(seconds / 60);
    if (mins < 60) return `${mins} min`;

    const hrs = Math.floor(mins / 60);
    const rem = mins % 60;

    return rem ? `${hrs}h ${rem}m` : `${hrs}h`;
}

export function getApproxMinutesFromSeconds(seconds?: number | null): number | null {
    if (seconds === null || seconds === undefined || Number.isNaN(seconds)) return null;
    if (seconds <= 0) return 1;

    return Math.max(1, Math.ceil(seconds / 60));
}

export function getSectionProgress(
    progress: IFormProgress | null | undefined,
    formTemplateSectionId?: number | string | null
) {
    if (formTemplateSectionId === undefined || formTemplateSectionId === null) return null;
    if (!progress?.sections?.length) return null;

    const id = Number(formTemplateSectionId);

    return progress.sections.find((s) => Number(s.formTemplateSectionId) === id) ?? null;
}

export function getSectionApproxMinutes(
    progress: IFormProgress | null | undefined,
    formTemplateSectionId?: number | string | null
): number | null {
    const sectionProgress = getSectionProgress(progress, formTemplateSectionId);
    return getApproxMinutesFromSeconds(sectionProgress?.remainingSeconds);
}